var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadIconSvg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "#ffffff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 22L22.9282 15.25H9.0718L16 22Z",
  fill: "#ffffff"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 10,
  width: 4,
  height: 6,
  fill: "#ffffff"
})));
export { SvgDownloadIconSvg as ReactComponent };
export default __webpack_public_path__ + "72fc0d4ac9931cd51030da14c3970b56.svg";